import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { profilesAPI } from '../utils/api';
import toast from 'react-hot-toast';
import './Professionals.css';

const ORG_TYPES = [
  { value: 'club', label: 'نادي رياضي' },
  { value: 'academy', label: 'أكاديمية' },
  { value: 'federation', label: 'اتحاد رياضي' },
  { value: 'school', label: 'مدرسة / جامعة' },
  { value: 'company', label: 'شركة رياضية' },
  { value: 'government', label: 'جهة حكومية' },
];

export default function Organizations() {
  const [orgs, setOrgs] = useState([]);
  const [loading, setLoading] = useState(true);
  const [page, setPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [filters, setFilters] = useState({ search: '', org_type: '', location: '' });

  useEffect(() => { fetchOrgs(); }, [page, filters]);

  const fetchOrgs = async () => {
    setLoading(true);
    try {
      const res = await profilesAPI.getOrganizations({ page, limit: 12, ...filters });
      setOrgs(res.data.organizations || []);
      setTotalPages(res.data.pages || res.data.pagination?.pages || 1);
    } catch {
      toast.error('فشل تحميل المؤسسات');
    } finally {
      setLoading(false);
    }
  };

  const handleFilterChange = e => {
    setFilters(prev => ({ ...prev, [e.target.name]: e.target.value }));
    setPage(1);
  };

  return (
    <div className="professionals-page">
      <div className="page-hero">
        <div className="hero-content">
          <h1>المؤسسات والأندية الرياضية</h1>
          <p>تعرّف على أبرز الجهات الرياضية الباحثة عن الكفاءات</p>
        </div>
      </div>

      <div className="pros-container">
        <div className="pros-filters">
          <input type="text" name="search" className="form-input filter-search"
            placeholder="🔍 ابحث باسم المؤسسة..."
            value={filters.search} onChange={handleFilterChange} />
          <select name="org_type" className="form-input" value={filters.org_type} onChange={handleFilterChange}>
            <option value="">جميع الأنواع</option>
            {ORG_TYPES.map(t => <option key={t.value} value={t.value}>{t.label}</option>)}
          </select>
          <input type="text" name="location" className="form-input"
            placeholder="الموقع"
            value={filters.location} onChange={handleFilterChange} />
        </div>

        {loading ? (
          <div className="loading-grid">
            {[...Array(6)].map((_, i) => <div key={i} className="skeleton-card" />)}
          </div>
        ) : orgs.length === 0 ? (
          <div className="empty-state">
            <span className="empty-icon">🏟</span>
            <h3>لا توجد مؤسسات مطابقة</h3>
          </div>
        ) : (
          <div className="pros-grid">
            {orgs.map(org => (
              <Link to={`/profile/${org.uuid}`} key={org.uuid} className="pro-card org-card">
                <div className="pro-card-header">
                  {org.logo ? (
                    <img src={org.logo}
                      alt={org.org_name} className="pro-avatar" />
                  ) : (
                    <div className="pro-avatar-placeholder org-placeholder">
                      {org.org_name?.[0]}
                    </div>
                  )}
                  <div className="pro-info">
                    <h3>{org.org_name}</h3>
                    <p className="pro-role">{ORG_TYPES.find(t => t.value === org.org_type)?.label || org.org_type}</p>
                    {org.location && <p className="pro-location">📍 {org.location}</p>}
                  </div>
                </div>
                {org.bio && <p className="pro-bio">{org.bio.slice(0, 120)}...</p>}
                <div className="pro-tags">
                  {org.sport_category_name && (
                    <span className="badge badge-outline">{org.sport_category_name}</span>
                  )}
                  {org.founded_year && (
                    <span className="badge badge-secondary">تأسس {org.founded_year}</span>
                  )}
                </div>
                <div className="pro-card-footer">
                  <span className="org-jobs-count">💼 {org.jobs_count || 0} وظيفة نشطة</span>
                  <span className="view-profile-btn">عرض الملف ←</span>
                </div>
              </Link>
            ))}
          </div>
        )}

        {totalPages > 1 && (
          <div className="pagination">
            <button className="btn btn-outline" onClick={() => setPage(p => p - 1)} disabled={page === 1}>السابق</button>
            <span className="page-info">{page} / {totalPages}</span>
            <button className="btn btn-outline" onClick={() => setPage(p => p + 1)} disabled={page === totalPages}>التالي</button>
          </div>
        )}
      </div>
    </div>
  );
}
